<template>
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>预警管理</el-breadcrumb-item>
        <el-breadcrumb-item>预警阀值</el-breadcrumb-item>
      </el-breadcrumb>
      <el-form  :inline="true">
        <!-- <el-form-item v-if="user.username == 'admin'" label="部门">
          <el-select v-model="depId"   placeholder="请选择"  size="small" @change="changeDept">
             <el-option
               v-for="item in deptData"
               :key="item.id"
               :label="item.departmentName"
               :value="item.id">
             </el-option>
           </el-select>
        </el-form-item> -->
        <el-form-item label="搜索：">
				<el-popover  v-model="visible">
                    <!-- <el-tooltip content="" placement=""> -->
					<el-input class="cp" readonly slot="reference" style="width: 230px;" autosize size="small" value="" placeholder="选择部门/集中器" v-model="getJZ"></el-input>
					<!-- </el-tooltip> -->
					<el-tree :data="deptData"  :expand-on-click-node="false" :highlight-current="true"  @node-click="handleNodeClick"  :props="jzProps"  accordion  node-key='id'>
						<span class="custom-tree-node" slot-scope="{  data }">
							<span>
								<i v-if="!data.parentId && !data.isJz"  class="el-icon-office-building"></i>
								<i v-if="data.parentId"  class="el-icon-location-outline"></i>
								<i v-if="data.isJz"  class="el-icon-coin"></i>
								{{ data.departmentName }}
							</span>

						</span>

					</el-tree>
				</el-popover>

			</el-form-item>
            <el-form-item label="">
               <el-input v-model="tableParam.alarmName" size="small" placeholder="预警名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-button @click="search" style="margin-bottom: 10px;" type="primary"  icon="el-icon-search" size="small">搜索</el-button>
                <prems-button size="small" type="primary" perms="alarm:alarmValueAdd" icon="el-icon-circle-plus-outline" @click="handelAddQf" label="添加" />
                  <!-- <el-button @click="handelAddQf" style="margin-bottom: 10px;" type="primary"  icon="el-icon-circle-plus-outline" size="small">添加</el-button> -->
            </el-form-item>
          
  
      </el-form>
  
          <el-table size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
            style="width: 100%;" stripe :max-height="tableHeight"  :header-cell-style="this.$store.state.headerCss">
            <el-table-column align="center" type="index" width="60" label="序号">
            </el-table-column>
            <el-table-column prop="alarmName" label="预警名称" sortable align="center">
            </el-table-column>
            <el-table-column prop="threshold" label="预警阀值" sortable align="center">
            </el-table-column>
            <!-- <el-table-column prop="updateDate" label="更新时间" sortable align="center">
            </el-table-column> -->
            <el-table-column align="center" label="操作" width="360">
              <template slot-scope="scope">
                <!-- <el-button type="primary" size="mini" icon="el-icon-edit" @click="handeDetail(scope.row)">编辑</el-button>
                <el-button type="warning" size="mini" icon="el-icon-s-tools"  @click="handelDateRuleMeter(scope.row)">设置</el-button>
                <el-button type="danger" size="mini" icon="el-icon-delete" @click="handelDeleQf(scope.row)">删除</el-button> -->
                <prems-button size="small" type="primary" perms="alarm:alarmValueEdit" icon="el-icon-edit" @click="handeDetail(scope.row)" label="编辑" />
                <prems-button size="small" type="warning" perms="alarm:alarmValueSet" icon="el-icon-s-tools" @click="handelDateRuleMeter(scope.row)" label="设置" />
                <prems-button size="small" type="danger" perms="alarm:alarmValueDelete" icon="el-icon-delete" @click="handelDeleQf(scope.row)" label="删除" />
              </template>
            </el-table-column>
          </el-table>
          <Pagination v-bind:child-msg="tableParam" @callFather="handelQfPage"></Pagination>
      
  
  <!-- 2023。11.30 添加编辑 -->
      <el-dialog :title="qfTitle" :visible.sync="formVisible" width="25%" :close-on-click-modal="false">
          <el-form  :model="qfFrom"  ref="editForm" :rules="rules" label-width="100px">
          <!-- <el-row :gutter="12" >
                <el-col :span="10" > -->
              <el-form-item prop="days" label="预警名称：" style="width: 76%">
                <el-input size="small"  placeholder="预警名称" v-model="qfFrom.alarmName" ></el-input>
              </el-form-item>
            <!-- </el-col>
  
            <el-col :span="10" style="position: relative;">  -->
              <el-form-item prop="threshold" label="阀值：" style="position: relative;width: 76%">
                <el-input size="small" placeholder="请输入阈值" v-model="qfFrom.threshold"></el-input>
                 <el-tooltip placement="top" effect="light">
                <div slot="content">
                  <p v-for="(item,index) in threshoTip" :key="index">{{item.value}}</p>
                  <!-- <p>阈值格式：</p> -->
                 
  
                  <!-- <p>1: (-∞,0) [0,20) [20,+∞)</p>
                  <p>2:不要填小数, 不要填中文标点符号 </p>
                  <p>3: 左边的数值必须小于右边的数值 0 < 20</p> -->
                </div>
                <i class="el-icon-warning iconPositon" ></i>
              </el-tooltip>
              </el-form-item>
             
            <!-- </el-col>
          
  
          </el-row> -->
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="formVisible = false">取消</el-button>
              <el-button size="small" type="primary" :loading="saveLoading" class="title" @click="save">保存</el-button>
          </div>
      </el-dialog>

  
  
      <!-- 2023.11.20 绑定计量点 -->
      <el-dialog title="绑定计量点" :visible.sync="bindFormVisible" width="45%"  :close-on-click-modal="false">
          <el-button type="primary" size="small" style="margin-bottom: 10px;" @click="handelAddMeter">添加</el-button>
          <el-button type="danger" size="small" style="margin-bottom: 10px;" @click="removeBindMeter" :loading="unbindLoading" :disabled="!selectMeter.length" >删除</el-button>
          <div style="line-height: 30px;">当前绑定的计量点</div>
          <el-table size="small" :data="meterList" height="500px" border v-loading="loadWallet"  @selection-change="getDeleMeterIds">
              <el-table-column type="selection"></el-table-column>
              <el-table-column label="id" prop="id" width="100"></el-table-column>
              <el-table-column label="计量点名称" prop="meterPointName"></el-table-column>
          </el-table>
          <div style="line-height: 40px;">共计:{{meterList.length}}</div>
          <div slot="footer" class="dialog-footer">
              <el-button size="small" @click='bindFormVisible = false'>关闭</el-button>
              <!-- <el-button size="small" type="primary" :loading="setLoading" class="title" @click="subBindMeter('editForm')">保存</el-button> -->
          </div>
      </el-dialog>
  
  <!-- 2023.11.20 选择计量点 -->
      <el-dialog title="选择计量点" :visible.sync="meterVisible" width="45%" :close-on-click-modal="false">
        <el-form  :inline="true">
  
          <el-form-item >
            <el-input style="width: 100%;" size="small"  v-model="meterParams.meterPointName" placeholder="请输入计量点名称" clearable></el-input>
          </el-form-item>
          <el-form-item >
            <el-button size="small" type="primary" @click="getAllMeterList">搜索</el-button>
          </el-form-item>
        </el-form>
          <el-table size="small" v-loading="walletLoad" :data="allMeterList" height="500px" border  @selection-change="getMeterIds">
              <el-table-column type="selection"></el-table-column>
              <el-table-column label="id" prop="id" width="100"></el-table-column>
              <el-table-column label="计量点名称" prop="meterPointName"></el-table-column>
  
          </el-table>
  
          <div slot="footer" class="dialog-footer">
              <el-button size="small" @click='meterVisible = false'>取消</el-button>
              <el-button size="small" type="primary" :loading="setLoading" class="title" @click="saveBindMeter">保存</el-button>
          </div>
      </el-dialog>
  
    </div>
  </template>
  
  <script>
  import { add_alarm_config,list_alarm_config,update_alarm_config,del_alarm_config,sms_alarm_config_bind_meter,
    list_meter_by_config,getMeterInfoByDeptAndName,sms_alarm_config_unbind_meter } from '../../api/alarmManager'
  import { getDepartmentTerminalInfoLis,getTerminalInfoByDepId, } from '../../api/energyMG'
  import { handleDeletePage} from '../../utils/util.js'
  import PremsButton from "@/views/permission/PreButtom";
  import Pagination from '../../components/Pagination'
  import { getDepartmentIdByMeterInfos } from '../../api/energyMG'
  
     export default{
       data(){
         return{
            deptData:[],
            visible:false,
            getJZ:'',
            qfTitle:"",
            formVisible:false,
            qfFrom:{
                 departmentId: '',
                 id:'',
                 alarmName: '',
                 threshold: ""
           },
        //    查询表格参数
           tableParam:{
            departmentId:'',
            alarmName:'',
            currentPage:1,
            pageSize: 10,
            total:0,
        },
        dataList:[],
        saveLoading:false,
        allMeterList:[],
        meterIds:[],
        meterList:[],
        curId:"",
        unbindFormVisible:false,
        unbindMeterIds:[],
        unbindLoading:false,
        selectMeter:[],
        loading:false,
        unbindLoading:false,
        jzProps:{
			    label: function( data,node ){
		      },
			    children: 'deps',
		    },
        getMeter:{
             meterPointName:"",
             depId:"",
             currentPage: 1,
             pageSize: 10,
           },
         walletLoad:false,
        meterVisible:false,
        tableHeight:0,
        depId:0,
        deptType:-1,
        user:{},
        bindFormVisible:false,
        loadWallet:false,
        setLoading:false,
        meterParams:{
          depId:'',
          meterPointName:'',
          configId:''
        },
        // 阈值提示
        threshoTip:[
          {value:'阈值格式：'},
          {value:'1: (-∞,0) [0,20) [20,+∞)'},
          {value:"2:不要填小数, 不要填中文标点符号"},
          {value:'3: 左边的数值必须小于右边的数值 0 < 20'},
        ],
        rules: {
                alarmName :[{ required: true, message: '请输入预警名称',trigger: 'blur' }],
                threshold :[{ required: true, message: '请输入阈值',trigger: 'blur' }],
            },   
         }
       },
       mounted() {
         this.$nextTick(() => {
           this.tableHeight = window.innerHeight - 360
         })
       },
       created() {
        this.getJzData();
        this.user = JSON.parse(sessionStorage.getItem('userdata'))

  
       },
       components: {
         Pagination,
         PremsButton,
       },
       methods:{
        // 搜索
        search(){
            this.getTableData();
        },
        // 2023.11.20 获取表格数据
        getTableData(){
            this.loading = true;
            list_alarm_config(this.tableParam).then(res=>{
            this.loading = false;
                if(res.status == 1){
                    this.dataList = res.data.data;
                    this.tableParam.total = res.data.totalCount
                }

            })
        },
        //  getDeptData(){
        //    list_prepaid_department().then(res => {
        //       if(res.status == 1){
        //         this.deptData = res.data
        //         this.depId = res.data[0].id
        //         this.qfFrom.departmentId = this.depId
        //          this.deptType = res.data[0].payType
        //         this.getQfData()
        //       }
        //    })
        //  },
        //2023.11.20获取集中器信息
			getJzData:function(){
				return new Promise((resolve,reject) => {
                    this.loading = true;
					getDepartmentTerminalInfoLis().then(res => {
                       
						if(res.status == 1){
							let arr = []
							this.deptData = this.changeData(res.data.menuDepList)
                            this.qfFrom.departmentId = this.deptData[0].id;
                            this.tableParam.departmentId = this.deptData[0].id
                            this.getJZ = this.deptData[0].departmentName
                            this.meterParams.depId = this.deptData[0].id
							this.getDepIds(JSON.parse(sessionStorage.getItem('userdata')).departmentId);
                            this.getTableData();
							resolve()
						}
						else{
							this.$message.error(res.msg)
						}
					})
				})

			},
            // 2023.11.20 集中器获取
            getDepIds(id){
        getTerminalInfoByDepId({depId:id}).then(res => {
        	if(res.status == 1){
        		let arr = []
        		res.data.forEach( item => {
        			let obj = {}
        			obj.id = item
        			arr.push(obj)
        		})

        		// this.formInline.terIds = JSON.stringify(arr)

        	}else{
        		this.$message.error(res.msg)
        	}
        })
      },
    //   2023.11.20 部门数据处理
      changeData( data ){
				data.forEach(item =>{
					if( item.terminalInfo){
						if(!item.deps){
							item.deps = []
						}
						item.terminalInfo.forEach(sitem => {
							let obj = {}
							obj.id = sitem.id
							obj.departmentName = sitem.terminalName
							obj.terminalCode = sitem.terminalCode
							obj.isJz= true
							item.deps.push(obj)
						})
					}

					if( item.deps){
						this.changeData(item.deps)
					}
				})

				return  data
			},
            // 选择部门
            handleNodeClick(data){
                console.log('data',data)
                this.visible = false
                this.getJZ = data.departmentName
                this.qfFrom.departmentId = data.id;
                this.tableParam.departmentId = data.id
                this.meterParams.depId = data.id;
                this.getTableData();
                if(data.isJz){
                    let idstr = JSON.stringify([{id:data.id}])
                    // this.formInline.terIds = idstr
                // this.search()
                }else{
                    //点击部门获得集中器id
                    this.getDepIds(data.id);
                }
            },
  
            // 2023.11.20 点击绑定计量点
         handelDateRuleMeter(row){
           this.bindFormVisible = true
           this.curId = row.id
           this.getMeterListByRuleId()
         },
  
//   2023.11.20 获取绑定的计量点
         getMeterListByRuleId(){
           let param = {
             ruleId:this.curId
           }
        
          list_meter_by_config(param).then(res => {
  
             if(res.status == 1){
               this.meterList = res.data
             }else{
               this.$message.error(res.msg)
             }
           })
         },

//   2023.11.20 点击添加计量点
         handelAddMeter(){
           this.meterVisible = true
           this.meterParams.meterPointName = ''
           this.getAllMeterList()
  
         },
  
        //  2023.11.20 获取所有计量点
         getAllMeterList(){
           this.walletLoad = true
            this.getMeter.depId = this.tableParam.departmentId
            this.meterParams.configId = this.curId
            getMeterInfoByDeptAndName(this.meterParams).then(res => {
             this.walletLoad = false
             if(res.status == 1){
               this.allMeterList = res.data
             }
           })
         },
       
        //  2023.11.20 获取删除计量点
         getDeleMeterIds(e){
           this.selectMeter = e
         },
  
        //  2023.11.20 点击分页
         handelQfPage(parm){
           this.tableParam.currentPage = parm.currentPage
           this.tableParam.pageSize = parm.pageSize
           this.getTableData()
  
         },
  
        // 2023.11.20 解绑
         removeBindMeter(){
           this.unbindLoading = true
           let param = {
                configId:this.curId,
                meterIds:this.selectMeter.map(item => item.id)
            }
         
            sms_alarm_config_unbind_meter(param).then(res => {
               this.unbindLoading = false
               if(res.status == 1){
                 this.$message.success('操作成功！')
                  this.getMeterListByRuleId()
  
               }else{
                this.$message.error(res.msg)
              }
             })
         },
  
        //  2023.11.20 绑定计量点
         saveBindMeter(){
           this.setLoading = true
           let param = {
            configId:this.curId,
            meterIds:this.meterIds.map(item => item.id)
           }
  
  
        //    if(this.dataType == 0){
  
            sms_alarm_config_bind_meter(param).then(res => {
               this.setLoading = false
               if(res.status == 1){
                 this.$message.success('操作成功！')
                 this.meterVisible = false
                 this.getMeterListByRuleId()
  
               }else{
                  this.$message.error(res.msg)
                }
             })
       
         },
  
        // 2023.11.20 获取选择的计量点id
         getMeterIds(e){
           this.meterIds = e
         },
  
        //  2023.11.20 点击添加
         handelAddQf(){
           this.qfFrom.departmentId = this.tableParam.departmentId
           this.qfFrom.alarmName = ""
           this.qfFrom.threshold = ""
           this.formVisible = true
           this.qfTitle = '添加'
           this.qfFrom.id = ''
         },
          //  2023.11.20 点击编辑
         handeDetail(row){
  
            this.qfFrom.id = row.id
            this.qfFrom.departmentId = row.departmentId
           this.qfFrom.alarmName = row.alarmName
            this.qfFrom.templateId = row.templateId
            this.qfFrom.threshold = row.threshold
            this.qfTitle = '修改'
            this.formVisible = true
  
  
         },
        //  保存添加、编辑
         save(){
            this.$refs['editForm'].validate( valid => {
              if(valid){
                if(this.qfTitle == '添加'){
                
                    this.addQf()
                
                }else{
                    this.updateQf()
  
                }
              }
            })
  
  
  
         },
        //  2023.11.20 添加预警阀值
         addQf(){
            this.saveLoading = true;
            add_alarm_config(this.qfFrom).then(res => {
                this.saveLoading = false;
             if(res.status == 1){
               this.$message.success('操作成功')
               this.getTableData()
               this.formVisible = false
             }else{
               this.$message.error(res.msg)
             }
           })
         },
        //  2023.11.20 修改
         updateQf(){
            this.saveLoading = true;
            update_alarm_config(this.qfFrom).then(res => {
                this.saveLoading = false;
             if(res.status == 1){
               this.$message.success('操作成功')
               this.getTableData()
               this.formVisible = false
             }else{
               this.$message.error(res.msg)
             }
           })
         },
  
        // 2023.11.20 删除表格阀值
         handelDeleQf(row){
           this.$confirm('确定要删除吗?', '信息', {
             confirmButtonText: '确定',
             cancelButtonText: '取消',
             type: 'warning'
           }).then(() => {
            //  this.curId = row.id
                del_alarm_config({ id:row.id }).then(res => {
                  if(res.status == 1){
                    this.$message.success("操作成功!")
                    // feat:2023.11.21 处理删除完一整页的数据后，实际页码还在当前页问题
                    this.tableParam.currentPage = handleDeletePage(this.tableParam.total, this.tableParam.pageSize, this.tableParam.currentPage)
                    this.getTableData()
                  }else{
                    this.$message.error(res.msg)
                  }
               })
            
         })
        },
       }
     }
  </script>
  
  <style scoped>
  .iconPositon{
      position: absolute;
      right: 0;
      top: 0;
    }
  </style>
  


// WEBPACK FOOTER //
// src/views/alarmManager/alarmValue.vue